import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

import { useAuth } from "../contexts/UserContext";
import { ONBOARDING_PATH } from "../config/navigation";

const ProtectedRoutes = ({ children }: { children: any }) => {
  const { isAuthenticated, user, isDataEntry, isInitialized } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // --- Effect: Role Based Redirect ---
  useEffect(() => {
    if (!isInitialized) return;
    if (user) {
      if (
        [
          "/account/profile",
          "/account",
          "/select-organization",
          // The wizard refuses ineligible callers with its own message; a redirect would hide why.
          ONBOARDING_PATH,
        ].includes(location.pathname)
      ) {
        return;
      }
      if (location.pathname !== "/emission/add" && isDataEntry()) {
        navigate("/emission/add", { replace: true });
      }
    }
  }, [user, location.pathname, isDataEntry, navigate, isInitialized]);

  // --- Loading / Auth Guards ---
  if (!isInitialized) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoutes;
